import { Component, inject } from '@angular/core';
import { AuthSessionService } from '../../auth-session.service';

@Component({
  imports: [],
  selector: 'app-faqs',
  styleUrl: './faqs.scss',
  templateUrl: './faqs.html',
})
export class Faqs {
  readonly version = inject(AuthSessionService).paxVersion;
}
